import { useApp, useCollectionItem, usePracticeAccess } from '@hb/react'
import { useMemo } from 'react'
import { useSelectedPracticeCollection } from './useSelectedPracticeCollection'

export const useSelectedPractice = () => {
  const { selectedPracticeId } = usePracticeAccess()
  const { appName } = useApp()
  const selectedPracticeCollection = useSelectedPracticeCollection()

  const { item, loading } = useCollectionItem(selectedPracticeCollection, selectedPracticeId)

  return useMemo(
    () => ({
      id: selectedPracticeId,
      practice: appName === 'app' ? undefined : (item ?? null),
      loading,
    }),
    [item, loading, appName, selectedPracticeId],
  )
}
